import { NavLink } from "react-router-dom";
import './AdminUserSettingsHeaderLink.css'

export function AdminUserSettingsHeaderLink() {
  return (
    <div className="admin-subheader-links">
      <ul>
        <li>
          <NavLink className={({ isActive }) => isActive ? "active" : "" } to="/user-settings/update-user">
            Update User
          </NavLink>
        </li>
        <li>
          <NavLink className={({ isActive }) => isActive ? "active" : "" } to="/user-settings/trolley-report">
            Trolley Report
          </NavLink>
        </li>
        <li>
          <NavLink className={({ isActive }) => isActive ? "active" : "" } to="/user-settings/additional-payments">
            Additional Payments
          </NavLink>
        </li>
        <li>
          <NavLink className={({ isActive }) => isActive ? "active" : "" } to="/user-settings/role-permissions">
            Role Permissions
          </NavLink>
        </li>
      </ul>
    </div>
  );
}